export { default as routes } from './routes'
export { default as vuex } from './store/index'
